import { Description, School, Work } from '@material-ui/icons';
import { getTrainingById } from '@webapps/business';
import { useQuery } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';

const Training = ({ id }) => {
  const { data: training = {} } = useQuery(getTrainingById, {
    key: ['training', id],
    variables: { id },
  });

  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  return (
    <>
      <div className={cx(global.infoText, classes.address)} >
        <School className={global.infoIcon} />
        <div>{training?.degree?.level?.label}</div>
      </div>
      <div className={cx(global.infoText, classes.address)} >
        <Work className={global.infoIcon}/>
        <div>{training?.label}</div>
      </div>
      <div className={cx(global.infoText, classes.address)} >
        <Description className={global.infoIcon}/>
        <div>{training?.trainingType?.label}</div>
      </div>
    </>
  );
};

const styles = ({ spacing, fontSizes }) => ({
  formations: {
    marginTop: spacing(2),
  },
  infoCandidat: { display: 'flex', alignItems: 'center' },
  tableHead: {
    '&.MuiTableCell-head': {
      color: 'white',
    },
  },
  address: {
    marginTop: spacing(1),
    display: 'flex',
    alignItems: 'center',
  },
});
export default Training